import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { UserProvider } from "@auth0/nextjs-auth0";
import { Box, ChakraProvider } from "@chakra-ui/react";
import "@fontsource/heebo/600.css";
import "@fontsource/lato/400.css";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { CustomHead, theme } from "@striver/ui";
import { useSegment } from "@striver/ui/src/analytics/react/segment";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { SWRConfig } from "swr";
var GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
config.autoAddCss = false;
export var enable3rdPartyScripts = "production" !== "development" && (process.env.NEXT_PUBLIC_BRANCH === "main" || process.env.NEXT_PUBLIC_BRANCH === "dev");
var TrackingProvider = function(param) {
    var children = param.children;
    var router = useRouter();
    var ref = useSegment(), page = ref.page, hasAnonymousId = ref.hasAnonymousId;
    useEffect(function() {
        var handleRouteChange = function(path) {
            var ref, ref1;
            var utms = new Map();
            (ref1 = (ref = path === null || path === void 0 ? void 0 : path.split("?")[1]) === null || ref === void 0 ? void 0 : ref.split("&")) === null || ref1 === void 0 ? void 0 : ref1.map(function(v) {
                return utms.set(v.split("=")[0], v.split("=")[1]);
            });
            var hasUtms = utms.has("utm_source") && utms.has("utm_medium") && utms.has("utm_campaign");
            if (hasAnonymousId) {
                page({
                    path: path,
                    context: {
                        campaign: {
                            name: hasUtms ? utms.get("utm_campaign") : null,
                            source: hasUtms ? utms.get("utm_source") : null,
                            medium: hasUtms ? utms.get("utm_medium") : null
                        }
                    }
                });
            }
        };
        router.events.on("routeChangeStart", function(url) {
            handleRouteChange(url);
        });
        router.events.on("routeChangeComplete", function() {
        // noop
        });
    }, [
        router.events
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
var LandingPageTemplate = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Providers, {
        children: /*#__PURE__*/ _jsxs(TrackingProvider, {
            children: [
                /*#__PURE__*/ _jsx(CustomHead, {
                    enable3rdPartyScripts: enable3rdPartyScripts,
                    GTM_ID: GTM_ID
                }),
                /*#__PURE__*/ _jsx(Box, {
                    bg: "white",
                    children: children
                })
            ]
        })
    });
};
// @ts-ignore
var Providers = function(props) {
    var router = useRouter();
    return /*#__PURE__*/ _jsx(UserProvider, {
        children: /*#__PURE__*/ _jsx(SWRConfig, {
            value: {
                // eslint-disable-next-line
                onErrorRetry: function(error, key, config, revalidate, param) {
                    var retryCount = param.retryCount;
                    // Never retry on 404.
                    if (error.status === 404) return;
                    // Never retry for a specific key.
                    if (key === "/api/user") return;
                    // Only retry up to 10 times.
                    if (retryCount >= 10) return;
                    // Retry after 5 seconds.
                    setTimeout(function() {
                        return revalidate({
                            retryCount: retryCount
                        });
                    }, 5000);
                },
                // eslint-disable-next-line
                onError: function(param, key) {
                    var response = param.response;
                    if ((response === null || response === void 0 ? void 0 : response.status) === 401 && (router === null || router === void 0 ? void 0 : router.route) !== "/404" && (router === null || router === void 0 ? void 0 : router.route) !== "/500") {
                        router.push("/api/auth/striver/login?returnTo=".concat(router.asPath));
                    }
                }
            },
            children: /*#__PURE__*/ _jsx(ChakraProvider, {
                theme: theme,
                children: props.children
            })
        })
    });
};
// @ts-ignore
export default function App(param) {
    var Component = param.Component, pageProps = param.pageProps;
    return /*#__PURE__*/ _jsx(LandingPageTemplate, {
        children: /*#__PURE__*/ _jsx(Component, _object_spread({}, pageProps))
    });
};
